import xray from '@mail/xray';
import type { Xray } from '@mail/xray';
declare const window: Window & {
    xray: Xray;
    xrayOptions: {
        global?: Parameters<Xray['setConfig']>[0];
    };
};
// задаем общие опции xray (прилетают из слота 946848)
const defineXray = () => {
    if (typeof window === 'undefined') {
        return;
    }
    const { global: xrayOptions } = window.xrayOptions || {};
    // см https://gitlab.corp.mail.ru/mail/mrg-xray
    if (xrayOptions) {
        xray.setConfig(xrayOptions);
        window.xray = xray;
    }
};
defineXray();
